import React from 'react';
import { Container, Card, Flex } from '@mantine/core';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import { useTranslation } from 'react-i18next';
import styles from '../ModelDetail.module.scss';

interface ErrorStateProps {
  minHeight?: string | number;
  errorMessage?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  minHeight = '300px',
  errorMessage,
}) => {
  const { t } = useTranslation();

  return (
    <Container size="xl" className={styles.container}>
      <Flex justify="center" align="center" style={{ minHeight }}>
        <Card w="50%" p="lg">
          <Flex justify="center" align="center" direction="column">
            <TextComponent color="muted">
              {t('mosaic.modelDetail.validation.fetchFailed')}
            </TextComponent>
            {errorMessage && (
              <TextComponent color="red" mt="md">
                {t(errorMessage)}
              </TextComponent>
            )}
          </Flex>
        </Card>
      </Flex>
    </Container>
  );
};
